import { BrowserRouter, Route, Routes } from "react-router-dom";
import { TranslationProvider } from "./i18n/TranslationContext";
import Home from "./pages/home/page";
import CreatorsPage from "./pages/creators/page";
import BrandsPage from "./pages/brands/page";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <TranslationProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/creators" element={<CreatorsPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TranslationProvider>
  );
}

export default App;
